import React from 'react';

import { Container, Image, Badge } from './styles';

import animalImg from '../../../assets/images/small-animal-example.png';
import getAnimalStatusColor from '../../../utils/getAnimalStatusColor';
import moment from 'moment';

interface IAnimal {
  name: string;
  label?: string;
  birth?: string;
  number: string;
  imageUrl?: string;
  belongs: boolean;
  state: string;
  gender: 'macho' | 'femea';
  customStyle?: any;
}

const Item: React.FC<IAnimal> = ({
  name,
  label,
  birth,
  number,
  imageUrl,
  belongs,
  state,
  gender,
  customStyle,
}) => {
  return (
    <Container style={customStyle}>
      <div>
        <Image src={imageUrl || animalImg} alt="Animal" />
        <div>
          {label ? (
            <span>{label}</span>
          ) : birth ? (
            typeof birth === 'number' ? (
              <span>birth</span>
            ) : (
              <span>
                {moment(birth.toString().replace('T00:00:00.000Z', '')).format(
                  'DD/MM/YYYY',
                )}
              </span>
            )
          ) : (
            <span>00/00/0000</span>
          )}
          <strong>{name}</strong>
        </div>
      </div>
      <Badge color={getAnimalStatusColor(belongs, state, gender) || ''}>
        Nº {number}
      </Badge>
    </Container>
  );
};

export default Item;
